/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card[_ngcontent-%COMP%]{margin-top:16px;margin-left:8px;margin-right:8px;height:46px;border-radius:4px;box-shadow:0 2px 8px 0 rgba(0,0,0,.11);background-color:#fff}.header-text[_ngcontent-%COMP%]{height:19px;font-family:ProductSans;font-size:16px;font-weight:700;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#515151}\n/*# sourceMappingURL=info-header.component.css.map*/"];
export { styles as styles };
